export * from './tech-support.component';
